/* eslint-disable prettier/prettier */
import { logo } from "./images/logo"

const headerFunction = (currentPage, pageCount) => {
    // if (currentPage === 1) {
    return logo
    // }
}

export { headerFunction }